import { CampoModeloVistoria } from './campo-modelo-vistoria';

/** Campos com que um modelo novo já nasce, com tags casando com TemplateHtmlPadrao.Gerar() (backend). */
export function camposModeloVistoriaPadrao(): CampoModeloVistoria[] {
  return [
    { id: 0, nome: 'Tipo de Vistoria', valorPadrao: null, tagHtmlPdf: 'tipoVistoria' },
    { id: 0, nome: 'Data de realização', valorPadrao: null, tagHtmlPdf: 'dataRealizacao' },
    { id: 0, nome: 'Tipo de Imóvel', valorPadrao: null, tagHtmlPdf: 'tipoImovel' },
    { id: 0, nome: 'Vistoriador', valorPadrao: null, tagHtmlPdf: 'vistoriador' },
    { id: 0, nome: 'Finalidade', valorPadrao: null, tagHtmlPdf: 'finalidade' },
    { id: 0, nome: 'Nome do locador', valorPadrao: null, tagHtmlPdf: 'locadorNome' },
    { id: 0, nome: 'Documento do locador', valorPadrao: null, tagHtmlPdf: 'locadorDocumento' },
    { id: 0, nome: 'Nome do locatário', valorPadrao: null, tagHtmlPdf: 'locatarioNome' },
    { id: 0, nome: 'Documento do locatário', valorPadrao: null, tagHtmlPdf: 'locatarioDocumento' },
    { id: 0, nome: 'Área útil', valorPadrao: null, tagHtmlPdf: 'areaUtil' },
    { id: 0, nome: 'Status do imóvel', valorPadrao: null, tagHtmlPdf: 'statusImovel' },
    { id: 0, nome: 'Energia', valorPadrao: null, tagHtmlPdf: 'energia' },
    { id: 0, nome: 'Nº do medidor de energia', valorPadrao: null, tagHtmlPdf: 'energiaMedidor' },
    { id: 0, nome: 'Água', valorPadrao: null, tagHtmlPdf: 'agua' },
    { id: 0, nome: 'Nº do medidor de água', valorPadrao: null, tagHtmlPdf: 'aguaMedidor' },
    { id: 0, nome: 'Gás', valorPadrao: null, tagHtmlPdf: 'gas' },
    { id: 0, nome: 'Nº do medidor de gás', valorPadrao: null, tagHtmlPdf: 'gasMedidor' },
    { id: 0, nome: 'Chaves', valorPadrao: null, tagHtmlPdf: 'chaves' },
    { id: 0, nome: 'Controle do portão', valorPadrao: null, tagHtmlPdf: 'controlePortao' },
    { id: 0, nome: 'Cartão de acesso', valorPadrao: null, tagHtmlPdf: 'cartaoAcesso' },
    { id: 0, nome: 'Informações da administradora', valorPadrao: null, tagHtmlPdf: 'informacoesAdministradora' },
    { id: 0, nome: 'Texto legal', valorPadrao: null, tagHtmlPdf: 'textoLegal' },
    { id: 0, nome: 'Pintura', valorPadrao: null, tagHtmlPdf: 'pintura' },
    { id: 0, nome: 'Limpeza', valorPadrao: null, tagHtmlPdf: 'limpeza' },
    { id: 0, nome: 'Vazamento', valorPadrao: null, tagHtmlPdf: 'vazamento' },
    { id: 0, nome: 'Observações gerais', valorPadrao: null, tagHtmlPdf: 'observacoesGerais' },
  ];
}
